
import uniq from 'lodash/uniq';
import uniqBy from 'lodash/uniqBy';

import { createSlice, Dispatch } from '@reduxjs/toolkit';
import axios2 from 'axios';
// utils
import axios from '../../utils/axios';
// import axios2 from '../../utils/axios2';

import { getAccessToken } from '../../auth/utils';

import {
    IBlogState, IBlogPostsPageState, IBlogListingPageState, IBlogNewEditPost
} from '../../@types/blog';



const initialPostsPageState: IBlogPostsPageState = {
    data: [],
    pageNumber: 0,
    pageSize: 0,
    isLastPage: true,
    newPosts: [],
    newPostsCount: 0,
    lastKey: undefined,
    lastTimestamp: "",
    keywords: "",
    scrollTopPos: 0,
    scrollTopPosUpdateTime: 0,
    selectedId: "",
    selectedIdUpdateTime: 0
};

const initialListingPageState: IBlogListingPageState = {
    data: [],
    total: 0,
    // pageNumber: 0,
    // pageSize: 0,
    // isLastPage: true,
    // exclusiveStartKey: [],
    // totalPages: 0,
};



const initialState: IBlogState = {
    isLoading: false,
    isUpdateSuccess: false,
    isUpdateFail: false,
    isProcessing: false,
    isLoadingMore: false,
    isFetching: false,
    isLoadingNew: false,


    // isProcessing: false,
    error: null,
    exploredResult: initialPostsPageState,
    postsPage: initialPostsPageState,
    userBlogPage: initialPostsPageState,
    userFavoriteBlogPage: initialPostsPageState,
    listingPage: initialListingPageState,
    tagsAry: [],
    metaKeywordsAry: [],
    post: null,
    postNew: null,
    postEdit: null,
    recentPosts: [],

};


const slice = createSlice({
    name: 'blog',
    initialState,
    reducers: {
        // resetState(state) {
        //     // // console.log(`reset(state);`);
        //     // console.log(`reset(state);`);
        //     // console.log(`initialState`)
        //     console.log(initialState)
        //     state = initialState;
        //     // console.log(`state`)
        //     console.log(state)
        // },
        resetState: () => initialState,

        // START LOADING
        startLoading(state) {
            state.error = null;
            state.isLoading = true;
        },

        ResetUpdateSuccess(state) {
            state.isLoading = false;
            state.isUpdateSuccess = false;
        },
        UpdateSuccess(state) {
            state.isUpdateSuccess = true;
        },
        UpdateFail(state) {
            state.isUpdateFail = true;
        },
        // startProcess(state) {
        //     state.isProcessing = true;
        // },
        startLoadingMore(state) {
            state.isLoadingMore = true;
        },
        startFetching(state) {
            state.isFetching = true;
        },
        startLoadingNew(state) {
            state.isLoadingNew = true;
        },



        ResetUpdateStatus(state) {
            state.isLoading = false;
            state.isUpdateSuccess = false;
            state.isUpdateFail = false;
        },

        ResetExploreResult(state) {
            state.exploredResult = initialPostsPageState
        },
        ResetBlogPosts(state) {
            state.postsPage = initialPostsPageState
        },
        ResetPostPage(state) {
            state.post = null
            state.recentPosts = []
        },
        ResetUserBlogPage(state) {
            state.userBlogPage = initialPostsPageState
        },
        ResetUserFavoriteBlogPage(state) {
            state.userFavoriteBlogPage = initialPostsPageState
        },


        startProcessing(state) {
            state.isProcessing = true;
        },
        stopProcessing(state) {
            state.isProcessing = false;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },

        resetError(state) {
            state.error = null;
        },

        // GET 
        getPostsSuccess(state, action) {

            state.postsPage = action.payload;
            state.isLoading = false;
        },


        getRecentPostsSuccess(state, action) {

            state.recentPosts = action.payload;
            state.isLoading = false;
        },


























        setExploreScrollTop(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            state.exploredResult.scrollTopPos = action.payload.scrollTop;
            state.exploredResult.scrollTopPosUpdateTime = now;
        },
        setExploreSeletedId(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            // // console.log('action.payload.selectedId: ', action.payload.selectedId);
            state.exploredResult.selectedId = action.payload.selectedId;
            state.exploredResult.selectedIdUpdateTime = now;
        },
        loadMoreResultSuccess(state, action) {
            state.exploredResult.data = state.exploredResult.data.concat(action.payload.data);
            state.exploredResult.lastKey = action.payload.LastEvaluatedKey;
            state.exploredResult.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
        },
        exploreResultSuccess(state, action) {
            state.exploredResult.data = action.payload.data;
            state.exploredResult.keywords = action.payload.keywords;
            state.exploredResult.newPosts = [];
            state.exploredResult.newPostsCount = 0;
            state.exploredResult.lastKey = action.payload.LastEvaluatedKey;
            state.exploredResult.lastTimestamp = action.payload.nextTimestamp;
            state.exploredResult.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        fetchNewResultSuccess(state, action) {
            if (state.exploredResult.newPosts?.length)
                state.exploredResult.newPosts = state.exploredResult.newPosts.concat(action.payload.data);
            else
                state.exploredResult.newPosts = action.payload.data
            state.exploredResult.newPostsCount = state.exploredResult.newPosts?.length || 0;
            state.exploredResult.lastTimestamp = action.payload.nextTimestamp;
            state.isFetching = false;
        },
        loadNewResultSuccess(state) {
            let newData;
            if (state.exploredResult.newPosts)
                newData = state.exploredResult.newPosts.concat(state.exploredResult.data)
            else
                newData = state.exploredResult.data
            state.exploredResult.data = newData;
            state.exploredResult.newPosts = [];
            state.exploredResult.newPostsCount = 0;
            state.isLoadingNew = false;
        },


















        setUserFavoriteBlogScrollTop(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            // // console.log(`scrollTop`, action.payload.scrollTop)
            state.userFavoriteBlogPage.scrollTopPos = action.payload.scrollTop;
            state.userFavoriteBlogPage.scrollTopPosUpdateTime = now;
        },
        setUserFavoriteBlogSeletedId(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            // // console.log(`selectedId`, action.payload.selectedId)
            state.userFavoriteBlogPage.selectedId = action.payload.selectedId;
            state.userFavoriteBlogPage.selectedIdUpdateTime = now;
        },

        loadMoreUserFavoriteBlogSuccess(state, action) {
            state.userFavoriteBlogPage.data = state.userFavoriteBlogPage.data.concat(action.payload.data);
            state.userFavoriteBlogPage.lastKey = action.payload.LastEvaluatedKey;
            state.userFavoriteBlogPage.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
        },
        loadUserFavoriteBlogSuccess(state, action) {
            state.userFavoriteBlogPage.profileEmail = action.payload.profileEmail;
            state.userFavoriteBlogPage.data = action.payload.data;
            state.userFavoriteBlogPage.newPosts = [];
            state.userFavoriteBlogPage.newPostsCount = 0;
            state.userFavoriteBlogPage.lastKey = action.payload.LastEvaluatedKey;
            state.userFavoriteBlogPage.lastTimestamp = action.payload.nextTimestamp;
            state.userFavoriteBlogPage.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },



























        setPostsScrollTop(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            // // console.log(`scrollTop`, action.payload.scrollTop)
            state.postsPage.scrollTopPos = action.payload.scrollTop;
            state.postsPage.scrollTopPosUpdateTime = now;
        },
        setPostsSeletedId(state, action) {
            const now = Math.floor(new Date().getTime() / 1000);
            // // console.log(`selectedId`, action.payload.selectedId)
            state.postsPage.selectedId = action.payload.selectedId;
            state.postsPage.selectedIdUpdateTime = now;
        },

        loadMorePostsSuccess(state, action) {
            state.postsPage.data = state.postsPage.data.concat(action.payload.data);
            state.postsPage.lastKey = action.payload.LastEvaluatedKey;
            state.postsPage.isLastPage = action.payload.isLast;
            state.isLoadingMore = false;
        },
        loadPostsSuccess(state, action) {
            state.postsPage.data = action.payload.data;
            state.postsPage.newPosts = [];
            state.postsPage.newPostsCount = 0;
            state.postsPage.lastKey = action.payload.LastEvaluatedKey;
            state.postsPage.lastTimestamp = action.payload.nextTimestamp;
            state.postsPage.isLastPage = action.payload.isLast;
            state.isLoading = false;
        },
        fetchNewPostsSuccess(state, action) {

            // console.log(action.payload.data)
            // // console.log('fetchNewPostsSuccess')
            // console.log(state.postsPage.newPosts)
            if (state.postsPage.newPosts?.length)
                state.postsPage.newPosts = state.postsPage.newPosts.concat(action.payload.data);
            else
                state.postsPage.newPosts = action.payload.data
            state.postsPage.newPostsCount = state.postsPage.newPosts?.length || 0;
            state.postsPage.lastTimestamp = action.payload.nextTimestamp;
            state.isFetching = false;
        },
        loadNewPostsSuccess(state) {
            let newData;
            if (state.postsPage.newPosts)
                newData = state.postsPage.newPosts.concat(state.postsPage.data)
            else
                newData = state.postsPage.data
            state.postsPage.data = newData;
            state.postsPage.newPosts = [];
            state.postsPage.newPostsCount = 0;
            state.isLoadingNew = false;
        },



        loadUserPostsSuccess(state, action) {
            // state.postsPage = action.payload;
            // if (Number(action.payload.pageNumber) === 1) {
            //     state.postsPage.data = action.payload.data;
            // } else {
            //     state.postsPage.data = state.postsPage.data.concat(action.payload.data);
            // }
            state.userBlogPage.data = action.payload.data;
            state.isLoading = false;
        },





        getBlogListSuccess(state, action) {
            // console.log(action.payload);

            state.listingPage.data = action.payload.data || [];

            state.listingPage.total = action.payload.total || 0;

            state.isLoading = false;
        },

        getTagListSuccess(state, action) {
            state.tagsAry = action.payload.tags;
            state.isLoading = false;
        },
        getMetakeywordsSuccess(state, action) {
            state.isLoading = false;
            state.metaKeywordsAry = action.payload.metaKeywords;
        },
        getTagNKeywordsSuccess(state, action) {
            // state.isLoading = false;
            state.tagsAry = action.payload.tags;
            state.metaKeywordsAry = action.payload.metaKeywords;
        },


        // GET PRODUCT
        getBlogEditSuccess(state, action) {
            state.postEdit = action.payload;
            state.isLoading = false;
        },

        // GET PRODUCT
        getBlogSuccess(state, action) {
            state.post = action.payload.blog;

            if (action.payload.recentPosts)
                state.recentPosts = action.payload.recentPosts;
            // console.log(action.payload.recentPosts)
            state.isLoading = false;

        },

        // GET PRODUCT
        readPostSuccess(state, action) {
            state.post = action.payload;
            state.isLoading = false;
        },

        likePostSuccess(state) {
            if (state.post) {
                state.post.isLike = true;
                state.post.numOfLike += 1;

            }

            state.isProcessing = false;
        },
        unlikePostSuccess(state) {
            if (state.post) {
                state.post.isLike = false;
                state.post.numOfLike -= 1;

            }
            state.isProcessing = false;
        },
        replyPostSuccess(state, action) {
            // if (state.post)
            //     state.post.isLike = true;
            const replyItem = action.payload.reply;

            // console.log(replyItem);

            if (state.post) {

                if (!state.post.comments)
                    state.post.comments = [];

                if (replyItem.replyTo) {
                    const commentsIndex = state.post.comments.findIndex(item => item.replyId === replyItem.replyTo)
                    const replyTo = state.post.comments[commentsIndex];
                    // if (replyTo.replyComment && replyTo.replyComment.length > 0) {
                    //     replyTo.replyComment.push(replyItem)
                    // } else {
                    //     // replyTo.hasReply = true;
                    //     replyTo.replyComment.push(replyItem)
                    // }

                    if (replyTo) {

                        if (!replyTo.replyComment)
                            replyTo.replyComment = [];


                        replyTo.replyComment.push(replyItem)
                        state.post.comments[commentsIndex] = replyTo;
                    }


                } else {
                    state.post.comments.push(replyItem);
                }

            }


            state.isProcessing = false;
        },
        deleteReplyPostSuccess(state, action) {
            // if (state.post)
            //     state.post.isLike = false;

            const replyId = action.payload.replyId;
            const replyTo = action.payload.replyTo;

            // // console.log(`replyId : ${replyId}`);
            // // console.log(`replyTo : ${replyTo}`);



            if (state.post) {
                if (replyTo) {
                    const replyToIndex = state.post.comments.findIndex(item => item.replyId === replyTo)

                    if (replyToIndex !== undefined && replyToIndex > -1) {
                        const replyToSubComment = state.post.comments[replyToIndex].replyComment;
                        const replyItemIndex = replyToSubComment.findIndex(item => item.replyId === replyId)
                        // state.post.comments[replyToIndex].replyComment[replyItemIndex];
                        if (replyItemIndex !== undefined && replyItemIndex > -1) {
                            replyToSubComment.splice(replyItemIndex, 1);
                            state.post.comments[replyToIndex].replyComment = replyToSubComment;
                        }
                    }
                } else {
                    const replyCommentList = state.post.comments;
                    const replyItemIndex = replyCommentList.findIndex(item => item.replyId === replyId)
                    if (replyItemIndex !== undefined && replyItemIndex > -1) {
                        replyCommentList.splice(replyItemIndex, 1);
                        state.post.comments = replyCommentList;
                    }
                }
            }

            state.isProcessing = false;
        },

    }
});



// Reducer
export default slice.reducer;


export const {
    // resetState,
    startLoading,
    hasError,
    resetError,
    startProcessing,
    stopProcessing,
    // loadMorePostsSuccess,
    // loadPostsSuccess,
    // loadNewPostsSuccess,
    // fetchNewPostsSuccess,
    // getPostsSuccess,
    // getTagListSuccess,
    // getMetakeywordsSuccess,
    // getTagNKeywordsSuccess,
    // getBlogListSuccess,
    // getBlogSuccess,
    // UpdateSuccess,
    // ResetUpdateSuccess,
    // ResetUpdateStatus,
    // UpdateFail,
    // likePostSuccess,
    // unlikePostSuccess,
    // replyPostSuccess,
    // deleteReplyPostSuccess,
    // startProcess,
} = slice.actions;



export function resetState() {
    // // console.log("Reset State")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.resetState());
    }

}



export function loadUserFavoriteBlog(profileEmail: string) {
    // // console.log("loadUserFavoriteBlog")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        // dispatch(slice.actions.ResetUserFavoriteBlogPage());
        try {
            const response = await axios.get(`/get-favorite-blog/${profileEmail}`);
            dispatch(slice.actions.loadUserFavoriteBlogSuccess({ profileEmail, ...response.data }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function loadMoreUserFavoriteBlog(profileEmail: string, lastKey: string) {
    // // console.log("loadMoreUserFavoriteBlog")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get(`/get-favorite-blog/${profileEmail}`, {
                params: {
                    lastKey
                }
            });
            dispatch(slice.actions.loadMoreUserFavoriteBlogSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}
















export interface LoadMorePostsInput {
    keywords?: string;
    lastKey?: any;
    lastTimestamp?: string;
}






export function loadUserPosts(profileEmail: string) {
    // // console.log("loadUserPosts")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        dispatch(slice.actions.ResetUserBlogPage());
        try {
            const response = await axios.get(`/user-blog/${profileEmail}`, {
                // params: {
                //     keywords
                // }
            });

            dispatch(slice.actions.loadUserPostsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}



// export function loadPosts(keywords?: string) {
export function loadPosts() {
    // // console.log("loadPosts")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        dispatch(slice.actions.ResetBlogPosts());
        try {
            const response = await axios.get('/explore-blog', {
                // params: {
                //     keywords
                // }
            });

            dispatch(slice.actions.loadPostsSuccess(response.data));
            // dispatch(slice.actions.loadPostsSuccess({ keywords, ...response.data }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}


export function loadMorePosts(input: LoadMorePostsInput) {
    // // console.log("loadMorePosts")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get('/explore-blog', {
                params: {
                    lastKey: input.lastKey,
                }
            });

            dispatch(slice.actions.loadMorePostsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function fetchNewPosts(input: LoadMorePostsInput) {
    // // console.log("fetchNewPosts")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startFetching());
        try {
            const response = await axios.get('/explore-blog', {
                params: {
                    keywords: input.keywords,
                    lastTimestamp: input.lastTimestamp,
                }
            });

            dispatch(slice.actions.fetchNewPostsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadNewPosts() {
    // // console.log("loadNewPosts")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingNew());

        try {
            dispatch(slice.actions.loadNewPostsSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}





export function setExploreScrollTop(scrollTop: number) {
    // // console.log("setExploreScrollTop")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setExploreScrollTop({ scrollTop }));
    }
}
export function setExploreSeletedId(selectedId: string) {
    // // console.log("setExploreSeletedId")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setExploreSeletedId({ selectedId }));
    }
}
export function setPostsScrollTop(scrollTop: number) {
    // // console.log("setPostsScrollTop")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setPostsScrollTop({ scrollTop }));
    }
}
export function setPostsSeletedId(selectedId: string) {
    // // console.log("setPostsSeletedId")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setPostsSeletedId({ selectedId }));
    }
}





export function setUserFavoriteBlogScrollTop(scrollTop: number) {
    // // console.log("setUserFavoriteBlogScrollTop")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setUserFavoriteBlogScrollTop({ scrollTop }));
    }
}
export function setUserFavoriteBlogSeletedId(selectedId: string) {
    // // console.log("setUserFavoriteBlogSeletedId")
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.setUserFavoriteBlogSeletedId({ selectedId }));
    }
}





































export function exploreResult(keywords: string) {
    // // console.log(`Load Result`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.ResetExploreResult());
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/explore-blog', {
                params: {
                    keywords
                }
            });

            dispatch(slice.actions.exploreResultSuccess({ keywords, ...response.data }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}


export function loadMoreResult(keywords: string, lastKey: string) {
    // // console.log(`Load More Result`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingMore());
        try {
            const response = await axios.get('/explore-blog', {
                params: {
                    keywords,
                    lastKey,
                }
            });

            dispatch(slice.actions.loadMorePostsSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function fetchNewResult(keywords: string, lastTimestamp: string) {
    // // console.log(`Fetch New Result`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startFetching());
        try {
            const response = await axios.get('/explore-blog', {
                params: {
                    keywords,
                    lastTimestamp
                }
            });

            dispatch(slice.actions.fetchNewResultSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}


export function loadNewResult() {
    // // console.log(`Load New Result`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoadingNew());

        try {
            dispatch(slice.actions.loadNewResultSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}

export function getTagNKeywords() {
    // // console.log(`Get Tags`)
    return async (dispatch: Dispatch) => {
        // dispatch(slice.actions.startLoading());

        try {
            const response = await axios.get('/tagnkeywords-list', {
            });
            // console.log(response);

            dispatch(slice.actions.getTagNKeywordsSuccess(response.data));

        } catch (error) {
            console.log(error);
        }

    }
}












// export function getPostsList(page_number: number, page_size = 10) {
export function getUserBlogTable() {
    // // console.log(`Get User Blog`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/blog-list', {
            });

            dispatch(slice.actions.getBlogListSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }
}

export function getBlogById(blogId: string) {
    // // console.log(`Get Blog`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get('/blog', {
                params: { blogId }
            });
            dispatch(slice.actions.getBlogEditSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}




export function getBlogEdit(blogId: string) {
    // // console.log(`Get Blog`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/edit-blog/${blogId}`, {
            });
            dispatch(slice.actions.getBlogEditSuccess(response.data.blog));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}


export function getBlog(blogId: string) {
    // // console.log(`Get Blog`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.ResetPostPage());
        // dispatch(slice.actions.ResetBlogPosts());
        dispatch(slice.actions.startLoading());
        try {
            const response = await axios.get(`/blog/${blogId}`, {
            });
            dispatch(slice.actions.getBlogSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
        }
    }

}




export function createPost(input: IBlogNewEditPost) {
    // // console.log(`Create Blog`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        dispatch(slice.actions.resetError());
        dispatch(slice.actions.ResetUpdateStatus());


        try {
            const _file = input.cover;
            if (_file instanceof Blob) {

                // // console.log("Input file")
                const bucketType = 'photo';
                const fileName = _file.name;
                const fileSize = _file.size.toString();
                const fileType = _file.type;

                const getUploadURLResponse = await axios.post('/get-upload-url', {
                    // accessToken,
                    bucketType,
                    fileName,
                    fileSize,
                    fileType,
                });

                const signedUrl = getUploadURLResponse.data.signedUrl;
                const b64URLCode = getUploadURLResponse.data.b64URLCode;
                const photoUrl = getUploadURLResponse.data.photoUrl;
                const previewURL = getUploadURLResponse.data.previewURL;
                if (signedUrl) {
                    const uploadFileResponse = await axios2.put(
                        signedUrl,
                        _file,
                        { headers: { 'Content-Type': fileType, }, },
                    );
                    // console.log(uploadFileResponse);
                    if (uploadFileResponse.status === 200) {
                        input.cover = photoUrl;
                    } else {
                        input.cover = '';
                    }
                }

            }

            const response = await axios.post('/create-blog', {
                ...input,
                // accessToken
            });


            // // console.log("test 1")
            dispatch(slice.actions.UpdateSuccess());
            // // console.log("test 2")

        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.UpdateFail());
        }


    }


}

export function editPost(input: IBlogNewEditPost) {
    // // console.log(`Edit Blog`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startLoading());
        dispatch(slice.actions.resetError());
        dispatch(slice.actions.ResetUpdateStatus());


        try {
            const _file = input.cover;
            if (_file instanceof Blob) {

                // // console.log("Input file")
                const bucketType = 'photo';
                const fileName = _file.name;
                const fileSize = _file.size.toString();
                const fileType = _file.type;

                const getUploadURLResponse = await axios.post('/get-upload-url', {
                    // accessToken,
                    bucketType,
                    fileName,
                    fileSize,
                    fileType,
                });



                const signedUrl = getUploadURLResponse.data.signedUrl;
                const b64URLCode = getUploadURLResponse.data.b64URLCode;
                const previewURL = getUploadURLResponse.data.previewURL;
                const photoUrl = getUploadURLResponse.data.photoUrl;
                if (signedUrl) {
                    const uploadFileResponse = await axios2.put(
                        signedUrl,
                        _file,
                        { headers: { 'Content-Type': fileType, }, },
                    );
                    // console.log(uploadFileResponse);
                    if (uploadFileResponse.status === 200) {
                        input.cover = photoUrl;
                    } else {
                        input.cover = '';
                    }
                }

            }

            // // console.log("input.releasedAt");
            // console.log(input.releasedAt);
            if (!input.blogId) {
                throw new Error("Blog Id is required");
            }
            const response = await axios.put(`/update-blog/${input.blogId}`, {
                ...input,
                // accessToken
            });

            dispatch(slice.actions.UpdateSuccess());


        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.UpdateFail());
        }


    }


}


export function deleteRows(blogIds: string[]) {
    // console.log(`Delete Blog`)
    return async (dispatch: Dispatch) => {

        dispatch(slice.actions.startLoading());
        dispatch(slice.actions.resetError());
        dispatch(slice.actions.ResetUpdateStatus());

        try {
            // console.log('delete api call')

            // delete-blog

            await axios.post('/delete-blog', {
                blogList: blogIds,
                // accessToken
            });

            dispatch(slice.actions.UpdateSuccess());

        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.UpdateFail());
        }
    }

}


export function deleteRow(blogId: string) {
    // console.log(`Delete Blog`)
    return async (dispatch: Dispatch) => {

        dispatch(slice.actions.startLoading());
        dispatch(slice.actions.resetError());
        dispatch(slice.actions.ResetUpdateSuccess());

        try {

            // console.log('delete api call')
            await axios.post('/delete-blog', {
                blogList: [blogId],
                // accessToken
            });

            dispatch(slice.actions.UpdateSuccess());

        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.UpdateFail());
        }
    }

}




export function likePost(blogId: string) {
    // console.log(`Like`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.put(`/favorite-blog/${blogId}`);
            dispatch(slice.actions.likePostSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}

export function unlikePost(blogId: string) {
    // console.log(`Unlike`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.delete(`/unfavorite-blog/${blogId}`);
            dispatch(slice.actions.unlikePostSuccess());
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            // dispatch(slice.actions.UpdateFail());
        }
    }
}





export function replyBlog(blogId: string, message: string, replyTo?: string) {
    // console.log(`Reply`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.post(`/reply-blog`, {
                message,
                blogId,
                replyTo,
            });
            dispatch(slice.actions.replyPostSuccess(response.data));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.UpdateFail());
        }
    }
}

export function deleteReplyBlog(replyId: string, replyTo?: string) {
    // console.log(`Delete Reply`)
    return async (dispatch: Dispatch) => {
        dispatch(slice.actions.startProcessing());
        try {
            const response = await axios.delete(`/delete-blogreply/${replyId}`);
            dispatch(slice.actions.deleteReplyPostSuccess({ replyId, replyTo }));
        } catch (error) {
            console.log(error);
            dispatch(slice.actions.hasError(error));
            dispatch(slice.actions.UpdateFail());
        }
    }
}



